import ArrowForward from '@mui/icons-material/ArrowForward';
import { FunctionComponent } from 'react';
import { Trans } from 'react-i18next';

import ExinMuiButton from './ExinMuiButton';

const ExinVoucherButton: FunctionComponent = () => (
  <ExinMuiButton
    href="https://mylogin.exin.nl/polarserver.asp?ExamRoomPlanning=1&Framed=1&NewSession=1&screen=frameset&ExamserviceID=1&voucherreservation=1"
    endIcon={<ArrowForward />}
    // @ts-ignore
    rel="noopener"
    // @ts-ignore
    target="_blank"
  >
    <Trans i18nKey="bookVoucherButton">I have an EXIN Anywhere Voucher</Trans>
  </ExinMuiButton>
);

export default ExinVoucherButton;
